import { Navigate, Outlet } from 'react-router';
import { FullPageSpinner } from '@/components/FullPageSpinner';
import { useSessionState } from '../sessionContext';
import { MFA_ENROLL_PATH, MFA_REPLACE_AUTHENTICATOR_PATH } from '../routes';

/**
 * Layer 2: has GET /api/v1/me resolved?
 *
 * The app is not signed in until it has. A Firebase sign-in only proves identity;
 * authorisation for this dashboard lives in the backend's own user table, which
 * invite-only onboarding populates separately.
 */
export function SessionGuard() {
  const { status } = useSessionState();

  switch (status) {
    case 'loading':
      return <FullPageSpinner label="Loading your session…" />;
    case 'not-provisioned':
      return <Navigate to="/access-not-provisioned" replace />;
    // Both targets sit outside this guard (router.tsx), or this is a loop.
    case 'mfa-enrollment-required':
      return <Navigate to={MFA_ENROLL_PATH} replace />;
    case 'mfa-reenrollment-required':
      return <Navigate to={MFA_REPLACE_AUTHENTICATOR_PATH} replace />;
    case 'error':
      return <Navigate to="/auth-error" replace />;
    case 'anonymous':
      return <Navigate to="/sign-in" replace />;
    case 'ready':
      return <Outlet />;
  }
}
